"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../common/util/constants/messages"));
const booking_1 = require("../common/util/booking");
const ProviderBookingButton = ({ provider, modalDisplayConfig, href, anchorTargetAttr, onClick }) => {
    const buttonText = (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, ((0, booking_1.isBookVirtualCare)(provider, modalDisplayConfig)
        ? messages_1.default.virtualcarebutton
        : messages_1.default.ctabutton)), (message) => (react_1.default.createElement("span", { "data-provider-id": provider.id, className: "button-text" }, message))));
    const isDisabled = (0, booking_1.isBookingDisabled)(provider);
    const attributes = {
        type: 'button',
        mode: 'primary',
        disabled: isDisabled,
        className: 'provider-booking-button',
        ['data-testid']: 'provider-booking-button',
        onClick
    };
    if (href && !isDisabled) {
        return (react_1.default.createElement(styles_1.BookAnchor, Object.assign({}, attributes, { href: href, target: anchorTargetAttr }), buttonText));
    }
    return react_1.default.createElement(styles_1.BookButton, Object.assign({}, attributes), buttonText);
};
exports.default = ProviderBookingButton;
//# sourceMappingURL=ProviderBookingButton.js.map